import { z } from 'zod';

import { BorrowerId, LoanNoteId, LosId, UserId } from '../../BrandedIds';
import { LoanNoteContactRole, LoanNoteContactType, LoanNotePin, LoanNoteTopic } from '../../loan/LoanNotes';
import { zodTemporalInstant } from '../../Temporal';
import { zodBrandedString } from '../../utils';

export const ExportableLoanNote = z
  .object({
    id: zodBrandedString<LoanNoteId>(),
    loanId: zodBrandedString<LosId>(),

    topics: z.array(LoanNoteTopic).optional(),
    contactType: LoanNoteContactType.optional(),
    contactRole: LoanNoteContactRole.optional(),

    comment: z.string(),
    pin: LoanNotePin.optional(),

    userId: zodBrandedString<UserId>().optional(),
    author: z.string().optional(),

    /**
     * Commented out for now while we resolve some unknowns:
     * https://github.com/willowservicing/willow/pull/10174#discussion_r2943102996
     */
    // timestamp: zodTemporalInstant,
    createdAt: zodTemporalInstant,
    updatedAt: zodTemporalInstant,

    borrowerId: zodBrandedString<BorrowerId>().optional(),
  })
  .meta({ title: 'LoanNote' });
export type ExportableLoanNote = z.infer<typeof ExportableLoanNote>;
